module.exports = __webpack_public_path__ + "static/img/footer1.c356154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer1.png
// module id = RDXx
// module chunks = 1